<template>
  <div class="max15">
    <div class="flex-browser single">
      <div class="nav left" :class="{vizzy: fileft < 0, white: white}" v-on:click="goLeft"></div>
      <div class="flex-mover" ref="flexparent">
        <div class="flex-images" ref="movebox" :style="{left: fileft + 'px', width: mwidth + 'px', height: mheight + 'px'}">
          <az-image v-for="item in artistData" :key="item.artist_id" :artist="item" v-on:click="goItem(item)" transparent />
        </div>
      </div>
      <div class="nav right" :class="{vizzy: !rightEnough, white: white}" v-on:click="goRight"></div>
    </div>
  </div>
</template>

<script>
import ViewablePanel from '@/mixins/ViewablePanel.js'
import AzImage from '@/components/widgets/AzImage.vue'
import '@/css/image-browser.css'
const imMargin = 16

export default {
  mixins:[ViewablePanel],
  props:{
    artists: Array,
    artist: Object,
    white: Boolean
  },
  components: {
    AzImage
  },
  data () {
    return {
      currentArtists: [],
      artistData:[],
      loc: 0,
      cols: 3,
      anim: false,
      loaded: false,
      fileft: 0,
      mwidth: 50000,
      mheight: 350,
      rightEnough: false
    }
  },
  mounted () {
    this.loaded = false
    if(this.inView) {
      if(!this.loaded) {
        this.loaded = true
        this.loadData()
      }
    }
    window.addEventListener('resize', this.setCols)
  },
  methods: {
    setCols () {
      let wd = window.innerWidth
      this.cols = 3
      if(wd > 960) this.cols = 4
      if(wd > 1300) this.cols = 5;
      this.setupWidths()
    },
    async setupWidths()
    {
      let imwid = (this.$refs.flexparent.offsetWidth / this.cols)
      this.mwidth = imwid * this.currentArtists.length
      this.mheight = imwid * 1.09
      this.fileft = 0
    },
    async loadData () {
      if(!this.artists) return
      let artists = []
      for(var each of this.artists) {
        let a = await this.$store.dispatch('fetchArtist', each)
        if(a){
          artists.push(a)
        }
      }
      let lang = this.$store.state.lang.toLowerCase()
      artists = artists.filter(el => { return  !el.hiddens.includes(lang) })
      this.artistData = artists
      this.currentArtists = this.artistData
      this.setCols()
    },
    async goItem(artist) {
      this.$k.sendGaEvent('ArtistPortfolio', 'Clicked', 'YouMightAlsoLike');
      this.$ixr.push('/artists/' + artist.portfolio_url)
    },
    getImWidth() {
      let el = this.$refs.movebox.querySelector('.imdiv')
      return el.offsetWidth + imMargin
    },
    farEnoughRight () {
      return this.loc + this.cols >= this.artistData.length
    },
    async goRight () {
      const imwidth = this.getImWidth()
      let width = imwidth * this.cols
      let npos = this.fileft - width
      let max = 0 - ((this.currentArtists.length - this.cols) * imwidth)
      if(npos < max){
        this.fileft = max
        this.rightEnough = true
      }
      else {
        this.fileft = npos
      }
    },
    async goLeft () {
      const imwidth = this.getImWidth()
      let npos = this.fileft + (imwidth * this.cols)
      if(npos > 0){
        this.fileft = 0
      }
      else {
        this.fileft = npos
      }
      this.rightEnough = false
    },
    beforeDestroy () {
      window.removeEventListener('resize', this.setCols)
    }
  },
  watch: {
    artists () {
      
      this.loaded = false
      this.loc = 0
      this.artistData = []
      this.currentArtists = []
      
      if(!this.loaded) {
        if(this.inView){
          
          this.loadData()
          this.loaded = true
        }
      }
  
    },
    inView () {
      if(this.inView) {
         if(!this.loaded) {
          this.loaded = true
          this.loadData()
        }
      }
      
    }
  }
}
</script>

<style>

.max15{
  max-width:1900px;
  margin-left:auto;
  margin-right:auto;
}



.flex-browser.single .flex-images{
  flex-wrap:nowrap;
  height:30vw;
  max-height:500px;
  width:500vw;
  transition:left 1s ease-in-out;
}

.flex-browser.single .flex-mover{
  overflow:hidden;
  width:calc(100% - 60px);
  flex-shrink:2;
}

.flex-browser.single .nav{
  flex-shrink:0;
}

.flex-browser.single .imdiv{
  margin-right:16px;
}

</style>